import { Routes, Route, Navigate } from 'react-router-dom';
import { Home } from './pages/Home';
import { Catalog } from './pages/Catalog';
import { ProductDetail } from './pages/ProductDetail';
import { Login } from './pages/Login';
import { PortalShell } from './pages/portal/PortalShell';
import { RequirePortal } from './pages/portal/RequirePortal';
import { LutronLanding } from './pages/lutron/Lutron';
import { LutronSystem } from './pages/lutron/LutronSystem';
import { LutronAsesoria } from './pages/lutron/Asesoria';
import { CASETA, RADIORA3, WALLBOX, MAESTRO, VIVE, HOMEWORKS } from './pages/lutron/content';
import { AdminShell } from './pages/admin/AdminShell';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { Vendedora } from './pages/Vendedora';
import { QuotePdf } from './pages/QuotePdf';
import { FichaTecnica } from './pages/FichaTecnica';
import { FichasBundle } from './pages/FichasBundle';
import { CatalogoPdf } from './pages/CatalogoPdf';
import { CompraPdf } from './pages/CompraPdf';
import { ReciboEntrega } from './pages/ReciboEntrega';
import { LandingPage } from './pages/LandingPage';
import { JoinDistributor } from './pages/JoinDistributor';
import { ResetPassword } from './pages/ResetPassword';
import { Compose } from './pages/Compose';
import { RailBuilder } from './pages/RailBuilder';
import { useAuth } from './lib/auth';
import { theme } from './styles/theme';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/catalogo" element={<Catalog />} />
      <Route path="/compose" element={<Compose />} />
      <Route path="/arma-tu-riel" element={<RailBuilder />} />
      <Route path="/producto/:sku" element={<ProductDetail />} />
      <Route path="/login" element={<Login />} />

      {/* Form público — solicitud para volverse distribuidor */}
      <Route path="/distribuidor" element={<JoinDistributor />} />

      {/* Destino del email "Restablecer contraseña" */}
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* Portal real para distribuidores logueados */}
      <Route path="/portal" element={<RequirePortal><PortalShell /></RequirePortal>} />
      <Route path="/preview/portal" element={<Navigate to="/portal" replace />} />

      {/* Lutron — landing + las 6 líneas (5 mayoreo + HomeWorks restringido) */}
      <Route path="/lutron" element={<LutronLanding />} />
      <Route path="/lutron/caseta"     element={<LutronSystem content={CASETA} />} />
      <Route path="/lutron/radiora3"   element={<LutronSystem content={RADIORA3} />} />
      <Route path="/lutron/maestro"    element={<LutronSystem content={MAESTRO} />} />
      <Route path="/lutron/wallbox"    element={<LutronSystem content={WALLBOX} />} />
      <Route path="/lutron/vive"       element={<LutronSystem content={VIVE} />} />
      <Route path="/lutron/homeworks"  element={<LutronSystem content={HOMEWORKS} />} />

      {/* Cuestionario guiado · NO listado en nav ni footer · noindex */}
      <Route path="/lutron/asesoria" element={<LutronAsesoria />} />

      {/* Redirects de URLs viejas */}
      <Route path="/lutron/ra2-select"     element={<Navigate to="/lutron/radiora3" replace />} />
      <Route path="/lutron/homeworks-qsx"  element={<Navigate to="/lutron/homeworks" replace />} />
      <Route path="/lutron/shading"        element={<Navigate to="/lutron" replace />} />

      <Route path="/admin" element={<RequireStaff><AdminShell /></RequireStaff>}>
        <Route index element={<AdminDashboard />} />
      </Route>

      {/* PWA vendedora · mobile-first, instalable como app */}
      <Route path="/vendedora" element={<RequireStaff><Vendedora /></RequireStaff>} />

      {/* PDF cotizaciones · ?modo=interno o sin para vista cliente */}
      <Route path="/cotizacion/:id/pdf" element={<QuotePdf />} />
      <Route path="/cotizacion/:id/fichas" element={<FichasBundle />} />

      {/* Ficha técnica por producto + catálogo showcase (sin precios) */}
      <Route path="/producto/:sku/ficha" element={<FichaTecnica />} />
      <Route path="/catalogo/pdf" element={<CatalogoPdf />} />
      <Route path="/compra/:id/pdf" element={<CompraPdf />} />
      <Route path="/entrega/:id/recibo" element={<ReciboEntrega />} />

      {/* Landing pages dinámicas (creadas por el agente de marketing) */}
      <Route path="/lp/:slug" element={<LandingPage />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function RequireStaff({ children }: { children: React.ReactNode }) {
  const { staff, loading, session } = useAuth();
  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.textMuted,
        fontFamily: theme.font.sans,
      }}>
        Cargando…
      </div>
    );
  }
  if (!session) return <Navigate to="/login" replace />;
  if (!staff?.active) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 12,
        color: theme.text,
        fontFamily: theme.font.sans,
      }}>
        <div style={{ fontSize: 18 }}>Tu cuenta no es staff de NULED.</div>
        <div style={{ color: theme.textMuted, fontSize: 14 }}>
          Pídele a un admin que te dé de alta en <code>public.staff</code>.
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
